import { useState, useRef, useEffect } from 'react'
import { NavbarTopAdmin, NavbarBottomAdmin } from '../admin/components'
import { useNavigate } from 'react-router-dom'
import ReactQuill from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { sostituisci } from '../../redux/artista'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"
import { NavbarNotAuth } from '../userNotAuth/components'
import AddImg from '../admin/components/addImg'

function AddArtista() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    let idUtente = localStorage.getItem('idUser')
    const [formData, setFormData] = useState({
        altro: '',
        città: '',
        cachet: '',
        cognome: '',
        durata: '',
        genere: '',
        fb: '',
        foto: [],
        incorporaUrl: '',
        video: '',
        nome: '',
        regione: '',
        descrizione: '',
        numero: '',
        telefono: '',
        gruppo: '',
        email: '',
        url: '',
        youtube: '',
        idUser: localStorage.getItem('id')
    })
    const [msg, setMsg] = useState({ foto: null, telefono: null, numero: null, descr: null })//messaggio email non valida
    const [validateTipologia, setValidateTipologia] = useState(null)//messaggio campo vuoto in genere
    const [text, setText] = useState({ emailValidate: '' })
    const [msgProgress, setMsgProgress] = useState({ string: null, failed: null })//barra del loader dopo submit 
    const [validate, setValidate] = useState({ videoStateMessage: null })
    const [subject, setSubject] = useState({ subject: null, pholder: null, valueSubject: null })

    const genere = useRef()
    const altro = useRef()// altro genere in options
    const descrizione = useRef()
    const telefono = useRef()
    const soggetto = useRef()

    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (formData.genere === '') {
            setValidateTipologia('*** Campo obbligatorio ***'); window.scrollTo(0, 150)
            genere.current.style.border = '1px solid red'; return
        } else
            if (formData.genere === 'Altro' && formData.altro === '') {
                setValidateTipologia('*** Campo obbligatorio ***'); window.scrollTo(0, 150); return
            }
            else
                if (formData.descrizione === '' || formData.descrizione.length > 4000) {
                    setMsg({ ...msg, descr: '*** Campo vuoto o troppo lungo ***' }); window.scrollTo(0, 850); return
                } else
                    if (formData.telefono && /^[0-9\s-]+$/.test(formData.telefono) === false) {
                        setMsg({ telefono: '*** Campo numerico ***' }); window.scrollTo(0, 950)
                        telefono.current.style.border = '1px solid red'; return
                    } else
                        if (!validRegex.test(formData.email) || formData.email === '') {
                            setText({ emailValidate: 'Email non valida' });
                            window.scrollTo(0, 1300); return
                        }
        // ---------------- SE TUTTO E' IN CHECK --------------------
        setMsgProgress({ string: ' Caricamento in corso...', failed: null })
        if (!idUtente || idUtente === 'null' || idUtente === 'undefined' || idUtente.trim() === '') {//creazione idUser
            idUtente = Math.random().toString(36).slice(2, 11)
            localStorage.setItem('idUser', idUtente)
        }
        const obj = { ...formData, ...subject, idUser: idUtente }
        try {
            const res = await axios.post(`/insertArtista`, obj)
            if (res.data === 'Success') {
                dispatch(sostituisci(obj))
                setTimeout(() => {
                    setMsgProgress({ string: null })
                    navigate('/addArtistSuccess', { replace: true })
                }, 1500)
            }
        } catch (err) { setMsgProgress({ failed: '*** Problemi con il server...riprova ***', string: null }); console.error(err); return }
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData({ ...formData, [name]: inputValue })
        setValidateTipologia(null); setText({ emailValidate: '' }); setMsg({ email: null, telefono: null }); setMsgProgress({ failed: null })
        genere.current.style.border = '1px solid black'
        descrizione.current.style.border = '1px solid black'; telefono.current.style.border = '1px solid black'
        if (name === 'genere' && value === 'Altro') {
            altro.current.style.display = 'block'
        } else
            if (name === 'genere' && value !== 'Altro' && altro.current.style.display === 'block') {
                altro.current.style.display = 'none'
            }
        if (name === 'altro') { setFormData({ ...formData, genere: inputValue }); return }
        if (name === 'telefono') {
            if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) { setMsg({ telefono: '*** Campo numerico ***' }) }; return
        }
        if (name === 'genere') {
            const ty = document.getElementById("soggetto")
            if (inputValue === 'Acrobata' && name === 'genere') {
                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Disciplina o numero", pholder: "es: Acrobati dei Tessuti" }); ty.required = true
            } else
                if (inputValue === 'Animatore' && name === 'genere') {
                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Tipologia", pholder: "es: Baby dance" }); ty.required = true
                } else
                    if (inputValue === 'Artista di strada' && name === 'genere') {
                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Swing band" }); ty.required = true
                    } else
                        if (inputValue === 'Band per tributi' && name === 'genere') {
                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Artista tributato", pholder: "es: tributo a 883" }); ty.required = true
                        } else
                            if (inputValue === 'Band musica live' && name === 'genere') {
                                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Cantautorato" }); ty.required = true
                            } else
                                if (inputValue === 'Cantante' && name === 'genere') {
                                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Piano bar" }); ty.required = true
                                } else
                                    if (inputValue === 'Circense' && name === 'genere') {
                                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Contorsionista" }); ty.required = true
                                    } else
                                        if (inputValue === 'Musicista' && name === 'genere') {
                                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Strumento", pholder: "es: Violinista" }); ty.required = true
                                        } else
                                            if (inputValue === 'Orchestra' && name === 'genere') {
                                                soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Big band" }); ty.required = true
                                            } else
                                                if (inputValue === 'Spettacolo per bambini' && name === 'genere') {
                                                    soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Gnomi e Fate" }); ty.required = true
                                                } else
                                                    if (inputValue === 'Scuola di ballo' && name === 'genere') {
                                                        soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Genere", pholder: "es: Salsa merengue" }); ty.required = true
                                                    } else
                                                        if (inputValue === 'Teatro dialettale' && name === 'genere') {
                                                            soggetto.current.style.display = 'block'; setSubject({ ...subject, subject: "Dialetto", pholder: "es: dialetto Pesarese" }); ty.required = true
                                                        }
                                                        else {
                                                            soggetto.current.style.display = 'none'; ty.required = false; ty.value = ''; setSubject({ valueSubject: null })
                                                        }
        }
    }
    const handleChangeSubject = (e) => {
        const { value } = e.target//attributi degli input
        setSubject({ ...subject, valueSubject: value })
    }
    function handleDescrizione(e) {
        setFormData({ ...formData, descrizione: e }); setMsg({ descr: null })
    }
    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {
                if (ETarget.size > 100000000) {
                    setValidate({ ...validate, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setValidate({ ...validate, videoStateMessage: 'Attendere...upload video in corso' })

                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setValidate({ ...validate, videoStateMessage: '*** Video troppo lungo (max 5 min)' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'
                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        // rinomino il video con un nome random
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setValidate({ ...validate, videoStateMessage: 'Video caricato con successo' })
                            setFormData({ ...formData, video: videoName }) //formData2.video è il nome che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setValidate({ ...validate, videoStateMessage: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setValidate({ ...validate, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData({ ...formData, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-video/${formData.video}`)
        } catch (err) { setValidate({ ...validate, videoStateMessage: '*** Problemi con la connessione...riprova ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setValidate({ ...validate, videoStateMessage: null })
    }
    useEffect(() => { window.scrollTo(0, 0) }, [])
    // useEffect(() => { console.log('formData:', formData) }, [formData])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='container' style={{ marginBottom: '3rem', marginTop: '5em' }}>
            <div style={{ float: 'right', cursor: 'pointer' }}>
                <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} width={45} alt="" onClick={() => {
                    navigate(-1)
                }} />
            </div>

            <h2 style={{ marginTop: '5em', clear: 'both' }}>Aggiungi un artista</h2>
            <p style={{ margin: '1rem 0 3rem 0' }}><i>Aggiungi un profilo artista per poter essere contattato dagli organizzatori
                degli eventi.</i>
            </p>
            <form onSubmit={handleSubmit}>
                <div className="col-md-6"></div>
                <label htmlFor='nome'>Nome </label>
                <input className="form-control fw-bold"
                    name="nome"
                    maxLength={25}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='cognome' className='mt-3'>Cognome </label>
                <input className="form-control fw-bold"
                    name="cognome"
                    maxLength={25}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='gruppo' className='mt-3'>Nome gruppo <i style={{ fontSize: 'small' }}>(opzionale)</i></label>
                <input className="form-control fw-bold"
                    name="gruppo"
                    maxLength={30}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='tipologia' className='mt-4'>Tipologia *</label>
                <select className="form-select mt-1 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                    name="genere" ref={genere}
                    onChange={handleChange} >
                    <option value=''></option>
                    <option value="Acrobata">Acrobata</option>
                    <option value="Animatore">Animatore</option>
                    <option value="Arte del palloncino">Arte del palloncino</option>
                    <option value="Artista del fuoco">Artista del fuoco</option>
                    <option value="Artista di strada">Artista di strada</option>
                    <option value="Band per tributi">Band per tributi</option>
                    <option value="Band musica live">Band musica live</option>
                    <option value="Bolle di sapone">Bolle di sapone</option>
                    <option value="Cabarettista">Cabarettista</option>
                    <option value="Cantante">Cantante</option>
                    <option value="Cartomante">Cartomante</option>
                    <option value="Circense">Circense</option>
                    <option value="Clown">Clown</option>
                    <option value="DJ">DJ Set</option>
                    <option value="Drag queen">Drag queen</option>
                    <option value="Giocoliere">Giocoliere</option>
                    <option value="Imitatore">Imitatore</option>
                    <option value="Mago">Mago</option>
                    <option value="Mimo">Mimo</option>
                    <option value="Musicista">Musicista</option>
                    <option value="Orchestra">Orchestra</option>
                    <option value="Ritrattista">Ritrattista</option>
                    <option value="Sand artist">Sand artist</option>
                    <option value="Scuola di ballo">Scuola di ballo</option>
                    <option value="Spettacolo per bambini">Spettacolo per bambini</option>
                    <option value="Spettacolo pirotecnico">Spettacolo pirotecnico</option>
                    <option value="Statua vivente">Statua vivente</option>
                    <option value="Street artist">Street artist</option>
                    <option value="Teatro burattini">Teatro burattini</option>
                    <option value="Teatro dialettale">Teatro dialettale</option>
                    <option value="Trampoliere">Trampoliere</option>
                    <option value="Truccabimbi">Truccabimbi</option>
                    <option value="Altro">Altro</option>
                </select>
                <div ref={altro} style={{ display: 'none', marginTop: '6px' }}>
                    <label>Inserisci la tipologia dello spettacolo (non la descrizione ma il genere)</label>
                    <input className="form-control fw-bold mt-1"
                        name="altro"
                        maxLength={200}
                        onChange={handleChange}
                        placeholder='es. Mangiafuoco'
                        type="text" />
                </div>
                {validateTipologia && <p style={{ color: 'red' }}><i>{validateTipologia}</i></p>}

                <div style={{ margin: '1em 0 0 1em', display: 'none' }} ref={soggetto}> {subject.subject} *
                    <input className="form-control" style={{ width: '80%' }} id="soggetto"
                        placeholder={subject.pholder}
                        maxLength={50}
                        name="valueSubject"
                        onChange={handleChangeSubject}
                        type="text" />
                </div>

                <label htmlFor='numero' className='mt-4'>Numero componenti *</label>
                <input className="form-control fw-bold"
                    name="numero" maxLength={50}
                    onChange={handleChange}
                    required
                    type="text" />
                {msg.numero && <div style={{ color: 'red' }}><i>{msg.numero}</i></div>}

                <label htmlFor='città' className='mt-4'>Città </label>
                <input className="form-control fw-bold"
                    name="città"
                    maxLength={45}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='regione' className='mt-4'>Regione </label>
                <input className="form-control fw-bold"
                    name="regione"
                    maxLength={35}
                    onChange={handleChange}
                    type="text" />

                <label htmlFor='durata' className='mt-4'>Durata dello show </label>
                <input className="form-control fw-bold"
                    name="durata"
                    maxLength={30}
                    onChange={handleChange}
                    placeholder='Es. 1 ora e 30 min'
                    type="text" />

                <label htmlFor='cachet' className='mt-4'>Cachet </label>
                <input className="form-control fw-bold"
                    name="cachet"
                    maxLength={6}
                    onChange={handleChange}
                    placeholder='€'
                    type="text" />

                <h4 style={{ marginTop: '3rem' }}>Descrivi la tua esibizione *<span style={{ color: 'maroon', fontSize: 'small' }}> (max 2000)</span></h4>
                <p><i>Ad esempio qualche particolare importante della tua performance di artista...</i></p>
                <div ref={descrizione}>
                    <ReactQuill className="textarea-quill"/*ql-container è la classe in App.css */
                        value={formData.descrizione}
                        theme="snow"
                        onChange={handleDescrizione}
                        placeholder="Es: La band può muoversi in formazione di quattro, cinque membri o full band..."
                        modules={{
                            toolbar: [
                                ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                                ['link'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                            ]
                        }}
                    />
                </div>
                <p><i>{formData.descrizione.length} *** max 4000</i>{msg.descr && <p className='text-danger'>{msg.descr}</p>}</p>

                <div><label htmlFor='telefono' className='mt-3'>Telefono </label>
                    <input className='form-control fw-bold' ref={telefono}
                        name='telefono'
                        maxLength={20}
                        onChange={handleChange}
                        type='text' />
                    {msg.telefono && <p style={{ color: 'red' }}><i>{msg.telefono}</i></p>}
                </div>

                <label htmlFor='email' className='mt-3'>Email * </label>
                <input className="form-control fw-bold"
                    name="email"
                    onChange={handleChange}
                    type="text"
                    required />
                {text.emailValidate && <p style={{ color: 'red' }}>{text.emailValidate}</p>}
                <div>{/*----------- LINK ---------------*/}
                    <h5 style={{ fontFamily: 'sans-serif', marginTop: '3rem' }}>LINK</h5>
                    <div style={{ marginLeft: '1rem' }}>
                        <label htmlFor='email' className='mt-1'>URL sito web</label>
                        <input className="form-control"
                            name="url"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.zona-eventi.it/'
                            type="text" />

                        <label htmlFor='email' className='mt-3'>URL Facebook</label>
                        <input className="form-control"
                            name="fb"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.facebook.com/'
                            type="text" />

                        <label htmlFor='email' className='mt-3'>URL YouTube</label>
                        <input className="form-control"
                            name="youtube"
                            maxLength={250}
                            onChange={handleChange}
                            placeholder='es: https://www.youtube.com/'
                            type="text" />
                    </div>
                </div>
                {/* ------------------------ aggiungi immagini ------------------------- */}

                <AddImg numero={[0]} folder={''} invioFoto={(e) => { setFormData({ ...formData, foto: e }) }} />

                {/* --------------------------- Incorpora Video ------------------ */}
                <div className='mt-5'>
                    <p className='fs-6'>INCORPORA UN VIDEO DA YOUTUBE
                        <span style={{ fontSize: 'x-small', backgroundColor: 'maroon', color: 'white', borderRadius: '5px', marginLeft: '1em', padding: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                document.getElementById('esempioIncorp').style.display = 'block'; setTimeout(() => {
                                    document.getElementById('esempioIncorp').style.display = 'none'
                                }, 15000)
                            }}
                        >esempio
                        </span>
                    </p>
                    <input className="form-control"
                        defaultValue={formData.incorporaUrl}
                        name='incorporaUrl'
                        onChange={handleChange}
                        placeholder='URL del video'
                        type='text' />
                    <div id='esempioIncorp' style={{
                        border: '1px solid grey', width: '40%', height: '220px', position: 'absolute', backgroundColor: 'whitesmoke', left: '14em',
                        fontSize: 'small', padding: '10px', display: 'none'
                    }}>
                        <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} style={{ cursor: 'pointer' }} alt=''
                            onClick={() => { document.getElementById('esempioIncorp').style.display = 'none' }} />
                        Sopra al video di YouTube clicca con il tasto destro del mouse e seleziona <i>Copia URL Video</i>. Poi incolla l'URL appena copiato nel campo <i>URL del video</i> qui sopra.
                    </div>
                </div>

                <h4 style={{ marginTop: '3rem' }}>AGGIUNGI VIDEO</h4>
                <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                    <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                        + Video
                        <span id="rotaryVideo" style={{ display: 'none' }}>
                            <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                        </span>
                    </label>
                    {formData.video &&
                        <div>
                            <div style={{ marginTop: '-28px' }}>
                                <button style={{ marginLeft: '9.5rem', border: 'transparent', backgroundColor: 'transparent' }}
                                    onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                    ❌
                                </button>
                            </div>

                            {/* ------------- preview del video proveniente da MYSQL saved in AWS ------------ */}
                            <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData.video}`} id={'videoPreview'}
                                style={{ width: '198px', height: '128px', borderRadius: '5px' }} controls />
                        </div>
                    }
                    <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                        type='file'
                        name='video'
                        accept="video/*"
                        onChange={videoChange} />
                </div>

                {/* ------------ barra di avanzamento ----------------------- */}
                <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                    <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                    </div>
                </div>
                {validate.videoStateMessage &&
                    <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{validate.videoStateMessage}</i></p>
                }

                {msgProgress.string &&
                    <h5 className='mt-3'>
                        <RotatingLines strokeColor="navy" strokeWidth='5' animationDuration='5' width='26' />
                        <span style={{ color: 'navy' }}>{msgProgress.string}</span>
                    </h5>}

                {msgProgress.failed && <p style={{ color: 'red', marginTop: '1rem' }}>{msgProgress.failed}</p>}

                <hr />

                <p className='mt-5'><i>* campi obbligatori</i></p>
                <div className='mt-2'>
                    <button className='btn btn-secondary' onClick={() => { navigate('/artisti', { replace: true }) }}>⇐ Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '1rem' }}>Avanti</button>
                </div>
            </form >
        </div >
        <DivBottom />
    </>)
}
export default AddArtista